import { io } from 'socket.io-client';


const socket = io("https://edukujme.onrender.com", {
    transports: ["websocket"],
  });
  
export default socket;
